import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import { WizardProvider } from "@/seo/WizardContext";
import { Toaster } from "@/components/ui/sonner";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import ServicePage from "@/pages/ServicePage";
import CityPage from "@/pages/CityPage";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import { SERVICE_ORDER, CITIES_META } from "@/seo/content";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <WizardProvider>
          <BrowserRouter>
            <WhatsAppButton />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              {SERVICE_ORDER.map((slug) => (
                <Route key={slug} path={`/${slug}`} element={<ServicePage slug={slug} />} />
              ))}
              {CITIES_META.map((c) => (
                <Route key={c.slug} path={`/${c.slug}`} element={<CityPage slug={c.slug} />} />
              ))}
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </WizardProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
